export const COMMUNITY_CODE = 'PETSURE';
export const ENCRYPTED_USER_STATE = 'state';
export const MAP_RESPONSE_TYPE = 'CSP';

export const INSTALMENT_STATUS = {
  INITIAL: '1',
  COMPLETED: '2',
  ERROR: '3'
};

export const INSTALMENT_STATUS_CODE = {
  INFO01: 'INFO01',
  INFO02: 'INFO02',
  INFO05: 'INFO05'
};

export const EMPTY_NEXT_PAYMENT_DATE = '1753-01-01';
